import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { CreateReturnInvoiceViewModel } from "../createReturnInvoice/createReturnInvoice-viewModel";
import { InvoicesListView } from "./invoicesList-view"
import { CompiledClass } from "src/formBuilder/datamodel/classGenerator";
import { CurrentCredentials } from "src/server/currentCredentials";

export class InvoicesListViewModel extends WindowViewModel implements IPopup {
    public getTitle(): string {
        return translate("invoicesList-viewModel.invoicesList", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.invoices = ObservableArray.create<Invoice>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new InvoicesListView();
    }
    public getTypeId(): string {
        return "VM-4DE82D1E-7643-4E2C-9B6D-B9F0F2EA5880"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set invoices(v: ObservableArray<Invoice>) { this._invoices = v; } public get invoices(): ObservableArray<Invoice> { return this._invoices; } private _invoices: ObservableArray<Invoice>;

    closePopup(resultCode: string) { }

    refresh() {
        this.loader.refresh();
    }
    public __AddToFilteringInformation__(filteringInformation: any, newFilter: any) {
        if (filteringInformation == null) {
            filteringInformation = {};
        }

        if (filteringInformation.Filters == null) {
            filteringInformation.Filters = {};
        }
        let filterString = filteringInformation.Filters.FilterString;
        let filter = [];
        if (stringIsNullOrEmpty(filterString) == false) {
            filter = JSON.parse(filterString);
        }
        filter.push(newFilter);
        filterString = JSON.stringify(filter);
        filteringInformation.Filters.FilterString = filterString;
        return filteringInformation;
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PurchaseServices/GetAllPurchaseInvoices', {
                FurtherQueryInfo: filteringInformation
            });
            this.invoices.update(...result.Invoices.map((x, i) => {
                let r = new Invoice(this);
                r.index = i + 1;
                r.factorNo = x.FactorNo;
                r.parentFactorNo = x.ParentFactorNo;
                r.id = x.Id;
                r.isReturn = !x.IsNormal;
                r.operatorPersonnelCode = x.PersonnelCode;
                r.operatorName = x.PersonnelName;
                r.sellerCode = x.SellerCode;
                r.sellerName = x.SellerName;
                r.warehouseTitle = x.WarehouseName;
                r.time = moment.utc(x.Time);
                r.total = x.Total;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
    async showInvoice(invoice: Invoice) {
        let selectedInvoice = new DetailedInvoice(this);
        selectedInvoice.loadByInvoiceId(invoice.id)
        this.showPopup(selectedInvoice);
    }

    async print(invoice: Invoice): Promise<void> {

        let selectedInvoice = new DetailedInvoice(this);
        await selectedInvoice.loadByInvoiceId(invoice.id);
        let compiledClass = new CompiledClass(this);
        let ids = [];
        if (selectedInvoice.preFactorConfirmerId != null) {
            ids.push(selectedInvoice.preFactorConfirmerId);
        }
        if (selectedInvoice.warehouseOperatorId != null) {
            ids.push(selectedInvoice.warehouseOperatorId);
        }
        let signs = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/GetMultiPersonnelSign', {
            PersonnelIds: ids

        });

        let preFactorConfirmer = signs.Signs.filter(q => q.PersonnelId == selectedInvoice.preFactorConfirmerId);
        let warehouseOperator = signs.Signs.filter(q => q.PersonnelId == selectedInvoice.warehouseOperatorId);

        let data = {
            FactorDate: compiledClass.__ConvertToPersianDate(selectedInvoice.time, "YYYY/MM/DD"),
            ApproverSign: (preFactorConfirmer.length != 0 && preFactorConfirmer[0].HasSign) ? preFactorConfirmer[0].SignData : null,
            WarehouseKeeperSign: (warehouseOperator.length != 0 && warehouseOperator[0].HasSign) ? warehouseOperator[0].SignData : null,
            factorNo: selectedInvoice.factorNo,
            Supplier: selectedInvoice.sellerName,
            SupplierPaymentInfo: selectedInvoice.sellerPaymentInfo,
            Items: selectedInvoice.lineItems.map((q, i) => {
                return {
                    RowNo: i + 1,
                    ProductName: q.productName,
                    Fee: q.fee,
                    Amount: q.amount,
                    TotalPrice: q.finalPrice,
                    ProductCode: q.productCode
                }
            })
        };

        new CompiledClass(this).__PrintReport('93bf4f4a-e524-4042-8ce4-1cd8d08b7486', data, 1);
    }
}

export class Invoice extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: InvoicesListViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: InvoicesListViewModel;

    public set factorNo(v: string) { this._factorNo = v; } public get factorNo(): string { return this._factorNo; } private _factorNo: string;
    public set parentFactorNo(v: string) { this._parentFactorNo = v; } public get parentFactorNo(): string { return this._parentFactorNo; } private _parentFactorNo: string;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set isReturn(v: boolean) { this._isReturn = v; } public get isReturn(): boolean { return this._isReturn; } private _isReturn: boolean;
    public set operatorPersonnelCode(v: string) { this._operatorPersonnelCode = v; } public get operatorPersonnelCode(): string { return this._operatorPersonnelCode; } private _operatorPersonnelCode: string;
    public set operatorName(v: string) { this._operatorName = v; } public get operatorName(): string { return this._operatorName; } private _operatorName: string;
    public set sellerCode(v: string) { this._sellerCode = v; } public get sellerCode(): string { return this._sellerCode; } private _sellerCode: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName; } private _sellerName: string;
    public set warehouseTitle(v: string) { this._warehouseTitle = v; } public get warehouseTitle(): string { return this._warehouseTitle; } private _warehouseTitle: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time; } private _time: moment.Moment;
    public set total(v: number) { this._total = v; } public get total(): number { return this._total; } private _total: number;

    edit() {
        this._typedParent.showInvoice(this);
    }

    async print() {
        this._typedParent.print(this);
    }
}

export class DetailedInvoice extends ViewModel implements IPopup {

    public getTypeId(): string { return 'detailedInvoice'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: InvoicesListViewModel) {
        super(parent);
        this._typedParent = parent;
        this.lineItems = ObservableArray.create<LineItem>();
        this.payments = ObservableArray.create<Payment>();
    }
    closePopup() { }
    private _typedParent: InvoicesListViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName; } private _sellerName: string;
    public set sellerCode(v: string) { this._sellerCode = v; } public get sellerCode(): string { return this._sellerCode; } private _sellerCode: string;
    public set sellerPaymentInfo(v: string) { this._sellerPaymentInfo = v; } public get sellerPaymentInfo(): string { return this._sellerPaymentInfo; } private _sellerPaymentInfo: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName; } private _personnelName: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode; } private _personnelCode: string;
    public set preFactorConfirmerId(v: string) { this._preFactorConfirmerId = v; } public get preFactorConfirmerId(): string { return this._preFactorConfirmerId; } private _preFactorConfirmerId: string;
    public set preFactorConfirmerName(v: string) { this._preFactorConfirmerName = v; } public get preFactorConfirmerName(): string { return this._preFactorConfirmerName; } private _preFactorConfirmerName: string;
    public set preFactorConfirmerCode(v: string) { this._preFactorConfirmerCode = v; } public get preFactorConfirmerCode(): string { return this._preFactorConfirmerCode; } private _preFactorConfirmerCode: string;
    public set warehouseOperatorId(v: string) { this._warehouseOperatorId = v; } public get warehouseOperatorId(): string { return this._warehouseOperatorId; } private _warehouseOperatorId: string;
    public set warehouseOperatorName(v: string) { this._warehouseOperatorName = v; } public get warehouseOperatorName(): string { return this._warehouseOperatorName; } private _warehouseOperatorName: string;
    public set warehouseOperatorCode(v: string) { this._warehouseOperatorCode = v; } public get warehouseOperatorCode(): string { return this._warehouseOperatorCode; } private _warehouseOperatorCode: string;

    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId; } private _warehouseId: string;
    public set warehouseTitle(v: string) { this._warehouseTitle = v; } public get warehouseTitle(): string { return this._warehouseTitle; } private _warehouseTitle: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time; } private _time: moment.Moment;
    public set additions(v: number) { this._additions = v; } public get additions(): number { return this._additions; } private _additions: number;
    public set deficits(v: number) { this._deficits = v; } public get deficits(): number { return this._deficits; } private _deficits: number;
    public set total(v: number) { this._total = v; } public get total(): number { return this._total; } private _total: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set factorNo(v: string) { this._factorNo = v; } public get factorNo(): string { return this._factorNo; } private _factorNo: string;
    public set parentFactorNo(v: string) { this._parentFactorNo = v; } public get parentFactorNo(): string { return this._parentFactorNo; } private _parentFactorNo: string;
    public set lineItems(v: ObservableArray<LineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<LineItem> { return this._lineItems; } private _lineItems: ObservableArray<LineItem>;
    public set payments(v: ObservableArray<Payment>) { this._payments = v; } public get payments(): ObservableArray<Payment> { return this._payments; } private _payments: ObservableArray<Payment>;

    public set canShowReturn(v: boolean) { this._canShowReturn = v; } public get canShowReturn(): boolean { return this._canShowReturn; } private _canShowReturn: boolean;
    public set canShowSend(v: boolean) { this._canShowSend = v; } public get canShowSend(): boolean { return this._canShowSend; } private _canShowSend: boolean;

    returnFactor() {
        var send = new CreateReturnInvoiceViewModel(this._typedParent, this.id);
        this._typedParent.showPopup(send);

    }

    async recieve() {
        try {
            let confirm = await this.messageBoxWarningYesNo(translate("invoicesList-viewModel.invoiceQuestion", {}), translate("invoicesList-viewModel.receiptOfInvoice", {}));
            if (confirm == 'no') {
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PurchaseServices/ReceivePurchaseInvoiceInWarehouse', {
                PurchaseFactorId: this.id,
                LineItemInfo: this.lineItems.map(x => {
                    return {
                        MeasuredProductId: x.measuredProductId,
                        WarehouseDescription: x.warehouseDescription,
                        Amount: x.amount
                    };
                })
            });
            if (result.IsSuccessful) {
                await this.messageBoxConfirmSuccess(translate("invoicesList-viewModel.successfullyRegistered", {}), translate("invoicesList-viewModel.receiptOfInvoice", {}));
                this.closePopup();
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async loadByInvoiceId(id: string) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PurchaseServices/GetPurchaseFactorDetail', {
                Id: id
            });
            this.id = id;
            this.sellerName = result.SellerName;
            this.sellerCode = result.SellerCode;
            this.sellerPaymentInfo = result.SellerPaymentInfo;
            this.preFactorConfirmerId = result.PreFactorConfirmerId;
            this.preFactorConfirmerName = result.PreFactorConfirmerName;
            this.preFactorConfirmerCode = result.PreFactorConfirmerCode;
            this.warehouseOperatorId = result.WarehouseOperatorId;
            this.warehouseOperatorName = result.WarehouseOperatorName;
            this.warehouseOperatorCode = result.WarehouseOperatorCode;
            this.personnelName = result.PersonnelName;
            this.personnelCode = result.PersonnelCode;
            this.warehouseTitle = result.WarehouseName;
            this.time = moment.utc(result.Time);
            this.additions = result.Additions;
            this.deficits = result.Deficits;
            this.total = result.Total;
            this.finalPrice = result.FinalPrice;
            this.factorNo = result.FactorNo;
            this.parentFactorNo = result.ParentFactorNo;
            this.canShowReturn = !result.IsReturnInvoice && !result.HasReturnInvoice;
            this.canShowSend = this.canShowReturn && !result.IsWarehouseBillCreated && !result.HasReturnInvoice;
            this.lineItems.update(...result.LineItems.map((x, i) => {
                let lineItem = new LineItem(this);
                lineItem.index = i + 1;
                lineItem.productName = x.ProductName;
                lineItem.productCode = x.ProductCode;
                lineItem.measuredProductId = x.MeasuredProductId;
                lineItem.id = x.LineItemId;
                lineItem.unitName = x.UnitName;
                lineItem.amount = x.Amount;
                lineItem.fee = x.Fee;
                lineItem.additions = x.Additions;
                lineItem.deficits = x.Deficits;
                lineItem.total = x.Total;
                lineItem.finalPrice = x.FinalPrice;
                lineItem.location = x.Locations;
                lineItem.canShowSend = this.canShowSend;
                return lineItem;
            }));
            this.payments.update(...result.Payments.map(x => {
                let payment = new Payment(this);
                payment.time = x.Time;
                payment.amount = x.Amount;
                payment.typeNo = x.TypeNo;
                payment.typeName = x.TypeName;
                payment.status = x.Status;
                payment.methodName = x.MethodName;
                payment.methodNo = x.MethodNo;
                payment.type = x.Type;
                return payment;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class LineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set measuredProductId(v: number) { this._measuredProductId = v; } public get measuredProductId(): number { return this._measuredProductId; } private _measuredProductId: number;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set fee(v: number) { this._fee = v; } public get fee(): number { return this._fee; } private _fee: number;
    public set additions(v: number) { this._additions = v; } public get additions(): number { return this._additions; } private _additions: number;
    public set deficits(v: number) { this._deficits = v; } public get deficits(): number { return this._deficits; } private _deficits: number;
    public set total(v: number) { this._total = v; } public get total(): number { return this._total; } private _total: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set location(v: string) { this._location = v; } public get location(): string { return this._location; } private _location: string;
    public set warehouseDescription(v: string) { this._warehouseDescription = v; } public get warehouseDescription(): string { return this._warehouseDescription; } private _warehouseDescription: string;
    public set canShowSend(v: boolean) { this._canShowSend = v; } public get canShowSend(): boolean { return this._canShowSend; } private _canShowSend: boolean;

}

export class Payment extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time; } private _time: moment.Moment;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set typeNo(v: number) { this._typeNo = v; } public get typeNo(): number { return this._typeNo; } private _typeNo: number;
    public set typeName(v: string) { this._typeName = v; } public get typeName(): string { return this._typeName; } private _typeName: string;
    public set status(v: string) { this._status = v; } public get status(): string { return this._status; } private _status: string;
    public set methodName(v: string) { this._methodName = v; } public get methodName(): string { return this._methodName; } private _methodName: string;
    public set methodNo(v: number) { this._methodNo = v; } public get methodNo(): number { return this._methodNo; } private _methodNo: number;
    public set type(v: number) { this._type = v; } public get type(): number { return this._type; } private _type: number;
}